export default "/images/e18944ea4214f5c48b268473919ef8a7.avif";